import React, { useEffect } from 'react'
import LoginForm from '../../layouts/auth/loginForm'
import { Navigate } from 'react-router-dom'
import { AuthSelector } from '../../store/reducers/auth/auth'
import { useSelector, useDispatch } from 'react-redux'
import './auth.css'

const Auth = () => {
    const dispatch = useDispatch()
    const AuthSelectors = useSelector(AuthSelector)

    if (AuthSelectors.isAuthenticated) return <Navigate to='/' />
    let body
    body = (
        <>
            <LoginForm />
        </>
    )
    return (
        <>
            <div className="auth-container">
                {body}
            </div>
        </>

    )
}

export default Auth